import { API_STATUS } from "../../constant/constant";
import { propertyDamageType } from "../constants/propertyDamageType";

const initialState = {
  flow: "propertyDamage",
  isError: false,
  isLoading: false,
};

export const propertyDamageReducer = (state = initialState, action) => {
  switch (action.type) {
    case propertyDamageType.POST_PROPERTY_DAMAGE_PENDING:
      return {
        ...state,
        status: API_STATUS.PENDING,
        isError: false,
        isLoading: true,
      };
    case propertyDamageType.POST_PROPERTY_DAMAGE_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        ...action.data,
        isError: false,
        isLoading: false,
      };
    case propertyDamageType.POST_PROPERTY_DAMAGE_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        isError: true,
        isLoading: false,
        error: { ...action.error },
      };
    case propertyDamageType.CLEAR_PROPERTY_DAMAGE:
      return {
        ...state,
        isError: true,
        isLoading: false,
        data: "",
      };
    default:
      return state;
  }
};

export const getPropertyDamageReducer = (state = initialState, action) => {
  switch (action.type) {
    case propertyDamageType.GET_PROPERTY_DAMAGE_PENDING:
      return {
        ...state,
        status: API_STATUS.PENDING,
        isError: false,
        isLoading: true,
      };
    case propertyDamageType.GET_PROPERTY_DAMAGE_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        ...action.data,
        isError: false,
        isLoading: false,
      };
    case propertyDamageType.GET_PROPERTY_DAMAGE_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        isError: true,
        isLoading: false,
        error: { ...action.error },
      };
    case propertyDamageType.CLEAR_PROPERTY_DAMAGES:
      return {
        ...state,
        isError: true,
        isLoading: false,
        data: "",
      };
    default:
      return state;
  }
};

export const updatePropertyDamageReducer = (state = initialState, action) => {
  switch (action.type) {
    case propertyDamageType.PUT_PROPERTY_DAMAGE_PENDING:
      return {
        ...state,
        status: API_STATUS.PENDING,
        isError: false,
        isLoading: true,
      };
    case propertyDamageType.PUT_PROPERTY_DAMAGE_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        ...action.data,
        isError: false,
        isLoading: false,
      };
    case propertyDamageType.PUT_PROPERTY_DAMAGE_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        isError: true,
        isLoading: false,
        error: { ...action.error },
      };
    case propertyDamageType.CLEAR_PROPERTY_DAMAGE:
      return {
        ...state,
        isError: true,
        isLoading: false,
        data: "",
      };
    default:
      return state;
  }
};
